export const adUnitIds = {
  banner: '',
  interstitial: '',
};

export function isAdMobAvailable(): boolean {
  return false;
}
